/**
 * Centralised route paths. Add to this file when introducing new routes;
 * never hardcode paths in components.
 *
 * Convention: agency-side routes are bare paths; portal routes are nested
 * under /portal.
 */

export const routes = {
  // Auth (both sides)
  login: '/login',
  signUp: '/signup',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',

  // Legal (public, no auth required)
  privacy: '/privacy',
  terms: '/terms',

  // Agency
  dashboard: '/dashboard',
  clients: '/clients',
  clientDetail: (id: string) => `/clients/${id}`,
  clientContactNew: (clientId: string) => `/clients/${clientId}/contacts/new`,
  clientContactEdit: (clientId: string, contactId: string) =>
    `/clients/${clientId}/contacts/${contactId}/edit`,
  engagements: '/engagements',
  engagementDetail: (id: string) => `/engagements/${id}`,
  projects: '/projects',
  project: (id: string) => `/projects/${id}`,
  projectProposals: '/projects/proposals',
  deliverables: '/deliverables',
  deliverable: (id: string) => `/deliverables/${id}`,
  documents: '/documents',
  invoices: '/invoices',
  reports: '/reports',
  inbox: '/inbox',
  notifications: '/notifications',
  auditLog: '/audit',
  reportNew: '/reports/new',
  reportEdit: (id: string) => `/reports/${id}/edit`,
  documentUpload: '/documents/upload',
  agencySettings: '/settings',
  projectTemplates: '/settings/project-templates',
  users: '/users',

  // Portal
  portalInvite: (token: string) => `/portal/invite/${token}`,
  portalLogin: '/portal/login',
  portalForgotPassword: '/portal/forgot-password',
  portalResetPassword: '/portal/reset-password',
  portalDashboard: '/portal',
  portalProjects: '/portal/projects',
  portalProject: (id: string) => `/portal/projects/${id}`,
  portalApprovals: '/portal/approvals',
  portalApproval: (id: string) => `/portal/approvals/${id}`,
  portalReports: '/portal/reports',
  portalReport: (id: string) => `/portal/reports/${id}`,
  portalDocuments: '/portal/documents',
  portalDocumentUpload: '/portal/documents/upload',
  portalInvoices: '/portal/invoices',
  portalProposeProject: '/portal/propose-project',
  portalNotifications: '/portal/notifications',
} as const;
